import React, { Component } from 'react';
import apiInstance from '../apiInstance';
import getFromUrl from '../Functions/getFromUrl';
import { connect } from 'react-redux';
// import Stripe from '../../utility/stripe';
import { activateWebsite } from './activatewebsite';

class ClaimWebsite extends Component {
	constructor(props) {
		super(props);
		this.state = {
			claimed: false,
			siteDetails: {}
		};
	}

	componentDidMount() {
		const siteId = getFromUrl('sid');
		apiInstance.get(`/dashboard/${siteId}`)
			.then((response) => {
				const siteDetails = response.data.websiteDetails;
				this.setState(() => {
					return ({
						claimed: (siteDetails.owner_id ? true : false),
						siteDetails: siteDetails
					})
				})
			})
			.catch(error => {
				console.error('Error fetching data:', error);
			});
	}

	claimNow = async (siteId) => {
		try {
			if(this.props.user?.email) {
				await apiInstance.put('/dashboard/claim', {
					userId: this.props.user.id,
					siteId: siteId
				});
				window.location.href = '/websites';
			} else {
				window.location.href = `/register?sid=${siteId}`;
			}
		} catch (err) {
			console.error('Claim failed:', err.message);
			this.setState({ error: 'Failed to claim website. Please try again.' });
		}
	}

	render() {
		const { claimed, siteDetails } = this.state;
        const pricing_amount = process.env.REACT_APP_STRIPE_MONTHLY_PRICING;

		return (
			<div>
				<h2>Claim Your Website & Start Getting More Leads Today</h2>

				<div>
					<p>You're just one step away from owning a fully built, ready-to-use professional website for your business.</p>
					<p>This website has already been created for <strong>{siteDetails.name}</strong> — all that's missing is your ownership.</p>
                    
					<p>This is <strong>not a demo</strong>. This is a <strong>real, production-ready website</strong> prepared specifically for your business.</p>

					<h3>💡 Why We Built This For You</h3>
					<p>Instead of forcing business owners to:</p>
					<ul>
						<li>Hire designers</li>
						<li>Wait weeks for development</li>
						<li>Pay thousands upfront</li>
						<li>Deal with technical headaches</li>
					</ul>
					<p>We flipped the model.</p>
					<ul>
						<li>We pre-built your website</li>
						<li>We handle hosting, updates, and security</li>
						<li>You only pay after you see it</li>
					</ul>
					<p>Zero risk. Zero setup. Immediate results.</p>

					<h3>💰 Simple, Transparent Pricing</h3>
					<h4>$0 Now. If you like what you see then ${pricing_amount} / Month — All Inclusive</h4>
					<ul>
						<li>No setup fees</li>
						<li>No hidden charges</li>
						<li>No long-term contracts</li>
                        <li>Start Free</li>
					</ul>
					<p>Includes:</p>
					<ul>
						<li>Website hosting</li>
						<li>Lifetime updates & security</li>
						<li>Technical support</li>
						<li>Content edits & assistance</li>
						<li>Performance monitoring</li>
						<li>Backup & uptime protection</li>
					</ul>
					<p>You can cancel anytime.</p>

					<p>Your competitors are already online. This ensures <strong>you don't fall behind</strong>.</p>

					<p><button className="mjs-btn mjs-btn-primary" onClick={() => this.claimNow(siteDetails.id)}>Claim Now</button></p>

					<h3>⚠️ Availability Notice</h3>
					<p>This website is <strong>reserved for only one business owner</strong>.</p>
					<p>Once claimed, it will be permanently locked to you and unavailable to competitors.</p>

				</div>

				{claimed && (
					<div>
						<p className="mjs-success-message">Thank You for your purchase. You have claimed your website.</p>
					</div>
				)}

			</div>

		);
	}
}
const mapStateToProps = (state) => {
	return (
		{
			user: state.currentUser,
		}
	)
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(ClaimWebsite);
